export default __webpack_public_path__ + "static/media/279.ac892c98.svg";